<app-details-wrapper
  [title]="account?.name"
  [headerIconName]="'accounts-primary'"
  [headerIconSize]="6"
  [isOverlay]="true"
  [headerIconWrapperClass]="
    'tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-color-border-subtle tw-bg-color-surface-page'
  "
  [showEditIcon]="!isAccountDetailsLocked"
  (onBackClicked)="handleBackClick()"
  (onEditClicked)="scrollToAccountDetail()"
>
  <div class="tw-flex tw-flex-col tw-gap-3 tw-bg-color-surface-page tw-px-1 tw-py-1 sm:tw-pb-4">
    <!-- Sync -->
    @if (
      account?.origin === Origin.basiq ||
      account?.origin === Origin.plaid ||
      account?.origin === Origin.fiskil ||
      account?.origin === Origin.plugin
    ) {
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-items-center tw-justify-between tw-pb-2">
          <span class="tw-text-[14px] tw-font-medium tw-uppercase tw-text-color-text-secondary">{{
            "dataFetching" | i18n
          }}</span>
          <div class="tw-flex tw-gap-1">
            @if (account?.origin === Origin.basiq && requiresReauth() && !isOrganizationOwned()) {
              <app-gloss-button
                [options]="{
                  text: 'reauthorize' | i18n,
                  isEnabled: true,
                  onClick: reauthorize.bind(this),
                  fullClass: 'btn-squared',
                }"
              ></app-gloss-button>
            }

            @if (account?.origin === Origin.plaid && requiresPlaidReauth()) {
              <app-gloss-button
                [options]="{
                  text: 'reauthorize' | i18n,
                  isEnabled: true,
                  onClick: reauthorize.bind(this),
                  fullClass: 'btn-squared',
                }"
              ></app-gloss-button>
            }

            @if (account?.origin === Origin.plaid && plaidItemWithNewAccounts()) {
              <app-gloss-button
                [options]="{
                  text: 'plaidAddAccounts' | i18n,
                  isEnabled: true,
                  onClick: addPlaidAccounts.bind(this),
                  fullClass: 'btn-squared',
                }"
              ></app-gloss-button>
            }

            <app-gloss-button
              [options]="{
                text: 'fetchData' | i18n,
                isEnabled: !isOrganizationOwned() && (!!pluginId() || canFetchSyncedData()),
                logoImage:
                  account?.origin === Origin.fiskil
                    ? 'images/fiskil.svg'
                    : pluginMetadata()?.imagePath,
                logoClass: 'tw-h-5',
                onClick: onFetchDataClick.bind(this),
                class: 'syncButton',
              }"
            ></app-gloss-button>
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-items-center">
          @if (statusTag) {
            <span
              class="tw-text-xs tw-font-medium tw-uppercase tw-py-1 tw-px-2.5 tw-rounded-full tw-border"
              [ngClass]="{
                'tw-text-color-money-in tw-bg-color-money-in-bg tw-border-color-money-in-border':
                  statusTag === SYNC_TAG.synced,
                'tw-text-color-status-warning-text tw-bg-color-status-warning-bg tw-border-color-status-warning-border':
                  statusTag === SYNC_TAG.syncing,
                'tw-text-color-status-error-text tw-bg-color-status-error-bg tw-border-color-status-error-border':
                  statusTag === SYNC_TAG.error,
              }"
              >{{ statusTag | i18n }}</span
            >
          }
          @if (!deviceDetectorService.isMobile()) {
            @if (pluginId()) {
              <app-gloss-button
                [options]="{
                  text: pluginMetadata()?.displayName ?? pluginId(),
                  isEnabled: true,
                  onClick: goToPlugin.bind(this),
                  class: 'syncButton',
                }"
              ></app-gloss-button>
            } @else {
              <ng-container *appRoleScope="'BETA_ACCESS'">
                <app-gloss-button
                  [options]="{
                    text: selectedInstitution.name,
                    isEnabled: true,
                    onClick: goToInstitutionDetail.bind(this),
                    class: 'syncButton',
                  }"
                ></app-gloss-button>
              </ng-container>
            }
          }
        </div>

        <div class="tw-flex tw-justify-between tw-items-center tw-mt-3">
          <span class="tw-text-color-text-secondary tw-text-[12px] tw-font-semibold tw-uppercase">{{
            "endTime" | i18n
          }}</span>
        </div>
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-1">
          <span class="tw-text-color-text-default tw-text-[12px] tw-font-medium">{{
            successfulStatus?.dateCreated.toISOString() | date: "yyyy-MM-dd HH:mm"
          }}</span>
        </div>

        @if (isOrganizationOwned()) {
          <p class="tw-text-xs tw-text-color-text-secondary tw-mt-2">
            {{ "fetchDataUnavailableForSharedAccount" | i18n }}
          </p>
        }

        @if (pluginId() === AUSTRALIAN_SUPER_PLUGIN_NAME) {
          <p class="tw-text-xs tw-text-color-text-secondary tw-mt-2">
            Australian Super requires a verification code each time you sync.
          </p>
        }
      </app-widget>
    }
  </div>
  <!-- TODO: reintroduce in the future -->
  <!-- account actions -->
  <!-- Small mobile-only breathing room below Delete Account — the wrapping panel in
       manage-accounts.component.html now stops exactly above the bottom nav, so this no longer
       needs to account for the nav's own height/safe-area itself. -->
  <div class="tw-flex tw-flex-col tw-gap-3 tw-bg-color-surface-page tw-px-1 tw-py-1 sm:tw-pb-4">
    @if (account.origin === Origin.manual) {
      <div class="tw-grid tw-grid-cols-2 tw-gap-[10px]">
        <app-gloss-button
          [options]="{
            text: 'addBalance' | i18n,
            isEnabled: true,
            icon: 'add',
            iconClass: 'tw-h-4 tw-w-4 tw-text-color-text-action',
            onClick: addBalance.bind(this),
            fullClass:
              'tw-w-full tw-h-[40px] tw-gap-[10px] tw-rounded-[12px] border-gradient-neuomorphic tw-bg-color-surface-page tw-text-color-text-default tw-text-sm tw-font-medium tw-shadow-elevation-card !tw-shadow-accounts-detail-surface hover:!tw-shadow-accounts-detail-surface active:!tw-shadow-accounts-detail-surface',
          }"
        ></app-gloss-button>
        <app-gloss-button
          [options]="{
            text: 'addTransaction' | i18n,
            isEnabled: true,
            icon: 'add-transaction',
            iconClass: 'tw-h-5 tw-w-5 tw-text-color-text-action',
            onClick: addTransaction.bind(this),
            fullClass:
              'tw-w-full tw-h-[40px] tw-gap-[10px] tw-rounded-[12px] border-gradient-neuomorphic tw-bg-color-surface-page tw-text-color-text-default tw-text-sm tw-font-medium tw-shadow-elevation-card !tw-shadow-accounts-detail-surface hover:!tw-shadow-accounts-detail-surface active:!tw-shadow-accounts-detail-surface',
            testId: 'add-transaction-button',
          }"
        ></app-gloss-button>
      </div>
    }

    <!-- My Transactions -->
    <div class="tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card">
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-min-w-0 sm:tw-flex-wrap tw-items-center tw-gap-2 tw-pb-2">
          <span
            titleWidget
            class="tw-text-lg tw-font-medium tw-uppercase tw-text-color-text-secondary sm:tw-text-sm"
          >
            {{ "myTransactions" | i18n }}
            <span class="tw-text-color-text-action">({{ transactionCount }})</span>
          </span>
          <div action class="tw-ml-auto tw-shrink-0">
            <app-gloss-button
              [options]="{
                link: '/views',
                text: 'pastView' | i18n,
                isEnabled: true,
                onClick: this.goToPastView.bind(this),
                fullClass:
                  'tw-w-auto tw-h-[36px] tw-px-4 tw-whitespace-nowrap tw-rounded-[8px] border-gradient-neuomorphic tw-bg-color-surface-page tw-text-color-text-default tw-text-sm tw-font-medium tw-shadow-elevation-card !tw-shadow-accounts-detail-surface hover:!tw-shadow-accounts-detail-surface active:!tw-shadow-accounts-detail-surface',
              }"
            ></app-gloss-button>
          </div>
        </div>
        <app-contribution-graph [accountId]="accountId"></app-contribution-graph>
      </app-widget>
    </div>

    <!-- Sharing -->
    <app-account-linked-collection
      *appRoleScope="'BETA_ACCESS'"
      [account]="account"
      (shareWithTeam)="openShareAccountDialog()"
    ></app-account-linked-collection>

    <!-- Footer for the share-account slide-out (see openShareAccountDialog) — passed to
         DialogFactory.shareAccount so DialogWrapperComponent can pin it to the panel's bottom. -->
    <ng-template #shareFooter>
      <div
        class="share-account-footer -tw-mx-8 tw-px-8 tw-py-4"
        style="background: var(--slideout-footer-bg, #e8e8ec)"
      >
        <app-gloss-button [options]="shareButtonOptions"></app-gloss-button>
      </div>
    </ng-template>

    <!-- Upload Files -->
    <ng-container *appRoleScope="'BETA_ACCESS'">
      <div class="tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card">
        <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
          <div class="tw-flex tw-min-w-0 sm:tw-flex-wrap tw-items-center tw-gap-2 tw-pb-2">
            <span
              class="tw-text-lg tw-font-medium tw-uppercase tw-text-color-text-secondary sm:tw-text-sm"
            >
              {{ "uploadFiles" | i18n }}
            </span>
            <div class="tw-ml-auto tw-shrink-0">
              <app-gloss-button
                [options]="{
                  link: '/cabinet',
                  text: 'editInCabinet' | i18n,
                  isEnabled: !isSystemAccount,
                  onClick: null,
                  fullClass:
                    'tw-w-auto tw-h-[36px] tw-px-4 tw-whitespace-nowrap tw-rounded-[8px] border-gradient-neuomorphic tw-bg-color-surface-page tw-text-color-text-default tw-text-sm tw-font-medium tw-shadow-elevation-card !tw-shadow-accounts-detail-surface hover:!tw-shadow-accounts-detail-surface active:!tw-shadow-accounts-detail-surface',
                }"
              ></app-gloss-button>
            </div>
          </div>

          <div id="fileContainer" class="tw-flex tw-justify-between tw-items-center tw-mt-3">
            <div class="tw-flex tw-overflow-hidden">
              @for (item of vaultFileDisplay.displayVualtFiles; track item.id) {
                <div
                  class="tw-flex tw-items-center tw-border tw-border-color-border-strong tw-rounded-lg tw-p-2 tw-mr-2"
                >
                  <div
                    class="tw-flex tw-items-center tw-justify-center tw-bg-color-surface-elevated tw-w-8 tw-h-8 tw-rounded-xl tw-border tw-border-color-border-strong tw-mr-2"
                  >
                    <icon [name]="'file-icon'" [size]="5"></icon>
                  </div>
                  <div class="tw-flex tw-flex-col tw-text-xs">
                    <span class="tw-text-color-text-default tw-max-w-48 tw-break-words">{{
                      item.name
                    }}</span>
                    @if (item.fileSize) {
                      <span class="tw-text-color-text-secondary tw-max-w-48 tw-break-words">
                        {{ item.fileSize }} bytes</span
                      >
                    }
                  </div>
                </div>
              }
            </div>
            @if (vaultFileDisplay.checkVaultItemsWraped()) {
              <app-gloss-button
                id="tooltipsMoreVault"
                [options]="{
                  fullClass:
                    'tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-xl tw-border tw-border-solid tw-border-color-border-strong',
                  text: '...',
                  isEnabled: !isSystemAccount,
                  onClick: moreVaultFile.bind(this),
                }"
              ></app-gloss-button>
            }
          </div>
        </app-widget>
      </div>
    </ng-container>

    <!-- My Symbol -->
    <div class="tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card">
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-min-w-0 sm:tw-flex-wrap tw-items-center tw-gap-2 tw-pb-2">
          <span
            class="tw-text-lg tw-font-medium tw-uppercase tw-text-color-text-secondary sm:tw-text-sm"
          >
            {{ "mySymbol" | i18n }}
          </span>
          <div class="tw-ml-auto tw-shrink-0">
            <app-gloss-button
              [options]="{
                link: '/symbol',
                text: 'symbolList' | i18n,
                isEnabled: true,
                onClick: null,
                fullClass:
                  'tw-w-auto tw-h-[36px] tw-px-4 tw-whitespace-nowrap tw-rounded-[8px] border-gradient-neuomorphic tw-bg-color-surface-page tw-text-color-text-default tw-text-sm tw-font-medium tw-shadow-elevation-card !tw-shadow-accounts-detail-surface hover:!tw-shadow-accounts-detail-surface active:!tw-shadow-accounts-detail-surface',
              }"
            >
            </app-gloss-button>
          </div>
        </div>
        <app-ag-grid-table
          [hasHeader]="true"
          [options]="table.options"
          [data]="table.data()"
          [customGridClass]="'ag-form-bg'"
          [hideGridBorders]="true"
        />
      </app-widget>
    </div>

    <!-- Account Detail -->
    <div
      id="account-detail-section"
      class="tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card"
    >
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-items-center tw-justify-between tw-pb-2">
          <span
            class="tw-text-lg tw-font-medium tw-uppercase tw-text-color-text-secondary sm:tw-text-sm"
          >
            {{ "accountDetail" | i18n }}
          </span>
        </div>
        <app-account-form
          [accountId]="accountId"
          [isEditMode]="true"
          [accountName]="accountName"
          [accountNickname]="accountNickname"
          [accountNamePlaceHolder]="accountNamePlaceHolder"
          (selectAccountProduct)="onSelectAccountProduct($event)"
          (selectCurrency)="selectCurrency($event)"
          [currency]="selectedCurrency"
          [institutionInputOptions]="institutionInputOptions"
          [selectedInstitution]="selectedInstitution"
          [selectedAccountProduct]="selectedAccountProduct"
          [isCurrencyEditMode]="false"
          [saveButtonOptions]="saveButtonOptions"
          [cancelButtonOptions]="cancelButtonOptions"
          [isReadOnly]="isSystemAccount"
          [accountType]="account.type"
          (accountNameChanged)="setAccountName($event)"
          (accountNicknameChanged)="setAccountNickname($event)"
        ></app-account-form>
      </app-widget>
    </div>

    <!--Sync Status Log-->
    @if (isDevMode()) {
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-items-center tw-justify-between tw-pb-2">
          <span class="tw-text-[14px] tw-font-medium tw-uppercase tw-text-color-text-secondary">
            {{ "syncStates" | i18n }}
          </span>
        </div>
        <div appGlossScroll class="tw-w-full tw-h-[555px] tw-overflow-auto">
          @for (status of account.c_syncStatus; track status.id) {
            <pre style="white-space: pre-wrap; word-wrap: break-word">{{ status | json }}</pre>
          }
        </div>
      </app-widget>
    }
    <app-gloss-button
      [options]="{
        text: 'deleteAccount' | i18n,
        isEnabled: !isSystemAccount,
        onClick: deleteAccount.bind(this),
        class: 'danger',
        testId: 'account-delete-button',
      }"
    ></app-gloss-button>
  </div>
</app-details-wrapper>
